export const DEEP_LINK_REPORT_IDS = [
  'google_auction_insights',
  'meta_audience_overlap',
] as const;

export type DeepLinkReportId = (typeof DEEP_LINK_REPORT_IDS)[number];

const DEEP_LINK_ID_SET: ReadonlySet<string> = new Set(DEEP_LINK_REPORT_IDS);

export const isDeepLinkReportId = (value: string): value is DeepLinkReportId =>
  DEEP_LINK_ID_SET.has(value);
